import { GET, POST } from "./utility";

const LOCAL_BASE_URL = "/resources";
const LOCAL_JSON_RESOURCES = "/lang/json";
const LOCAL_HTML_RESOURCES = "/lang/html";
const BASE_URL = "/api/be";

export const CONFIG_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: "/config.json",
};

export const LABELS_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_JSON_RESOURCES + "/labels",
};

export const ELENCO_PS_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_JSON_RESOURCES + "/prontosoccorso",
};

export const CODICI_COLORE_PS_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_JSON_RESOURCES + "/codiciColore",
};

export const FAQ_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_HTML_RESOURCES + "/faq",
};

export const COOKIE_POLICY_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_HTML_RESOURCES + "/cookie",
};

export const CONTACTS_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_HTML_RESOURCES + "/contacts",
};

export const PRIVACY_PS_API = {
  method: GET,
  baseUrl: LOCAL_BASE_URL,
  apiUrl: LOCAL_HTML_RESOURCES + "/privacyPs",
};

export const ENCOUNTER_API = {
  method: GET,
  baseUrl: BASE_URL,
  apiUrl: "/fhir/encounter",
};

export const SUBSCRIBE_API = {
  method: POST,
  baseUrl: BASE_URL,
  apiUrl: "/salutesimplex/subscribe",
};

export const UNSUBSCRIBE_API = {
  method: POST,
  baseUrl: BASE_URL,
  apiUrl: "/salutesimplex/unsubscribe",
};

export const CHECK_SUBSCRIPTION_API = {
  method: POST,
  baseUrl: BASE_URL,
  apiUrl: "/salutesimplex/events",
};

export const NOT_AVAILABLE_URL = "." + LOCAL_BASE_URL + "/notAvailable.html";
